<ng-container *transloco="let t; read: 'event-request-decision'">
  <p-selectButton
    class="block mb-2"
    ariaLabel="{{ t('eventRequestActionLabel') }}"
    [formControl]="decision"
    [options]="[
      { label: t('approveRequestLabel'), value: 'approve' },
      { label: t('denyRequestLabel'), value: 'deny' },
    ]"
  ></p-selectButton>

  <textarea
    class="w-full"
    pInputTextarea
    rows="1"
    [formControl]="comment"
    placeholder="{{ t('commentPlaceholder') }}"
  ></textarea>
</ng-container>
